import { useMarketingPagesTracking } from "../../../hooks/marketingPagesTracking";
import { GoogleTagManagerScript } from "../../../tracking/GoogleTagManager/GoogleTagManagerScript";
import { PartnersPageLayout } from "../../../pagelayouts/partners";

const Partners = () => {
    useMarketingPagesTracking();

    return (
        <>
            <GoogleTagManagerScript />
            <PartnersPageLayout />
        </>
    );
};

export async function getStaticProps() {
    return {
        props: {}
    };
}

export default Partners;
